import { useEffect, useState } from "react";
import { Formik, useFormik } from "formik";
import Swal from "sweetalert2";
import * as globalSettingsService from "../../../services/globalsetting.services";
import {
    handleServerValidations,
    hasPermission,
} from "../../../../../utils/commonfunction";
import {
    SWAL_SETTINGS,
} from "../../../../../utils/Constants";
import CustomCkeditor from "../../../common/customeditor";
import Loader from "../../../common/loader";
import { useDispatch } from "react-redux";
import { fetchDetailsApi } from "../../../../../redux/slices/globalDetails";
import * as Yup from 'yup';
import { Button, Modal } from "rsuite";

const GlobalPlatformSettings = (props) => {
    const dispatch = useDispatch()
    const [showdefault, setShowDefault] = useState({});
    const [contactNumber, setContactNumber] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [submitClicked, setSubmitClicked] = useState(false);
    const breadcrumbs = [
        { title: "Dashboard", url: "/admin/dashboard" },
        { title: "Global Settings", url: "" },
    ];
    const [previewimage, setPreviewImage] = useState("");
    const [previewImageGerman, setPreviewImageGerman] = useState("");
    const [showTermsModal, setShowTermsModal] = useState(false);

    useEffect(() => {
        globalSettingsService
            .Details()
            .then((response) => {
                setShowDefault(response && response.data ? response.data : []);
                setPreviewImage(response.data.login_bg_image);
                setPreviewImageGerman(response.data.login_bg_image_de);
                setContactNumber(JSON.parse(response?.data?.contact_no));
                setTimeout(() => {
                    setDataLoaded(true);
                }, 100);
            })
            .catch((error) => {
                console.log("error=====>", error);
                setDataLoaded(true);
            });
    }, []);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            TermsAndConditionOne: showdefault?.terms_and_condition_one || "",
            TermsAndConditionOneDe: showdefault?.terms_and_condition_one_de || "",
            TermsAndConditionTwo: showdefault?.terms_and_condition_two || "",
            TermsAndConditionTwoDe: showdefault?.terms_and_condition_two_de || "",
        },
        validationSchema: Yup.object({
            TermsAndConditionOne: Yup.string().trim().required("Terms and Condition One is required"),
            TermsAndConditionTwo: Yup.string().trim().required("Terms and Condition Two is required"),
        }),
        onSubmit: (values) => {
            setShowTermsModal(false);
        },
    });



    return (
        <>
            {/* <Breadcrums data={breadcrumbs} /> */}
            {dataLoaded ? (
                <Formik
                    validateOnChange={true}
                    enableReinitialize
                    initialValues={{
                        TermsAndConditionTwo:
                            showdefault && showdefault.terms_and_condition_two
                                ? showdefault.terms_and_condition_two
                                : "",
                        TermsAndConditionOne:
                            showdefault && showdefault.terms_and_condition_one
                                ? showdefault.terms_and_condition_one
                                : "",
                        TermsAndConditionTwoDe:
                            showdefault && showdefault.terms_and_condition_two_de
                                ? showdefault.terms_and_condition_two_de
                                : "",
                        TermsAndConditionOneDe:
                            showdefault && showdefault.terms_and_condition_one_de
                                ? showdefault.terms_and_condition_one_de
                                : "",
                        richtext:
                            showdefault && showdefault.login_content
                                ? showdefault.login_content
                                : "",
                        richtext_de:
                            showdefault && showdefault.login_content_de
                                ? showdefault.login_content_de
                                : "",
                        login_bg_image: showdefault && showdefault.login_bg_image ? showdefault.login_bg_image : "",
                        login_bg_image_de: showdefault && showdefault.login_bg_image_de ? showdefault.login_bg_image_de : "",
                        ticket_prefix_text:
                            showdefault && showdefault.ticket_prefix_text
                                ? showdefault.ticket_prefix_text
                                : "",
                        ticket_prefix_number:
                            showdefault && showdefault.ticket_prefix_number
                                ? showdefault.ticket_prefix_number
                                : "",
                        ticket_footer_text:
                            showdefault && showdefault.ticket_footer_text
                                ? showdefault.ticket_footer_text
                                : "",
                        cookies_content:
                            showdefault && showdefault.cookies_content
                                ? showdefault.cookies_content
                                : "",
                        cookies_content_de:
                            showdefault && showdefault.cookies_content_de
                                ? showdefault.cookies_content_de
                                : "",
                        pay_by_invoice_content:
                            showdefault && showdefault.pay_by_invoice_content
                                ? showdefault.pay_by_invoice_content
                                : "",
                        invoice_footer:
                            showdefault && showdefault.invoice_footer
                                ? showdefault.invoice_footer
                                : "",
                    }}
                    validate={(values) => {
                        let error = {};
                        console.log("error", error)
                        if (
                            !values.TermsAndConditionTwo ||
                            !values.TermsAndConditionTwo.trim()
                        ) {
                            error.TermsAndConditionTwo =
                                "Terms and condition text is required";
                        }
                        if (
                            !values.TermsAndConditionOne ||
                            !values.TermsAndConditionOne.trim()
                        ) {
                            error.TermsAndConditionOne =
                                "Terms and condition text is required";
                        }
                        if (!values.richtext || !values.richtext.trim()) {
                            error.richtext = "Login banner page text is required";
                        }
                        if (!values.invoice_footer || !values.invoice_footer.trim()) {
                            error.invoice_footer = "Invoice footer is required";
                        }
                        if (
                            !values.pay_by_invoice_content ||
                            !values.pay_by_invoice_content.trim()
                        ) {
                            error.pay_by_invoice_content =
                                "Pay by invoice content is required";
                        }
                        if (
                            !values.ticket_prefix_text ||
                            !values.ticket_prefix_text.trim()
                        ) {
                            error.ticket_prefix_text = "Ticket prefix text is required";
                        }
                        if (!values.ticket_prefix_number) {
                            error.ticket_prefix_number = "Ticket prefix number is required";
                        }
                        if (!values.cookies_content) {
                            error.cookies_content = "Cookies content is required";
                        }
                        return error;
                    }}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        setSubmitted(true);
                        let formData = new FormData();
                        formData.append(
                            "terms_and_condition_one",
                            formik.values.TermsAndConditionOne
                        );
                        formData.append(
                            "terms_and_condition_two",
                            formik.values.TermsAndConditionTwo
                        );
                        formData.append(
                            "terms_and_condition_one_de",
                            formik.values.TermsAndConditionOneDe
                        );
                        formData.append(
                            "terms_and_condition_two_de",
                            formik.values.TermsAndConditionTwoDe
                        );
                        formData.append("login_content", values.richtext);
                        formData.append("login_bg_image", values.login_bg_image);
                        formData.append("login_bg_image_de", values.login_bg_image_de);
                        formData.append("invoice_footer", values.invoice_footer);
                        formData.append("ticket_prefix_text", values.ticket_prefix_text);
                        formData.append(
                            "ticket_prefix_number",
                            values.ticket_prefix_number
                        );
                        formData.append("ticket_footer_text", values.ticket_footer_text);
                        formData.append("cookies_content", values.cookies_content);
                        formData.append("cookies_content_de", values.cookies_content_de);
                        formData.append(
                            "pay_by_invoice_content",
                            values.pay_by_invoice_content
                        );
                        formData.append("login_content_de", values.richtext_de);
                        globalSettingsService
                            .Add(formData)
                            .then((response) => {
                                if (response.success) {
                                    Swal.fire({
                                        icon: "success",
                                        text: 'Global settings updated successfully',
                                        ...SWAL_SETTINGS,
                                    });
                                    setTimeout(() => {
                                        setSubmitted(false);
                                        dispatch(fetchDetailsApi());
                                    }, 2000);
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        text: handleServerValidations(response),
                                        ...SWAL_SETTINGS,
                                    });
                                    setSubmitted(false);
                                }
                            })
                            .catch((error) => {
                                console.log("error ====> ", error);
                            });
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        isSubmitting,
                        setFieldTouched,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="row row-sm">
                                <div className="col-lg-12 col-md-12 animation_fade">
                                    <div className="card custom-card">
                                        <div className="">
                                            <div>
                                            </div>
                                            <div className="row row-sm">
                                                <div className="text-left mb-2">
                                                    <button
                                                        className="btn btn-warning"
                                                        type="button"
                                                        onClick={() => setShowTermsModal(true)}
                                                    >
                                                        <i className="fa fa-edit mr-1"></i>Edit Complete Profile Terms & Conditions
                                                    </button>
                                                </div>
                                                <div className="col-md-6 text-center form-group">
                                                    <label
                                                        htmlFor="login_bg_image"
                                                        className="text-left d-flex"
                                                    >
                                                        Login BG Image:{" "}
                                                    </label>
                                                    <input
                                                        className="form-control imgInput"
                                                        id="login_bg_image"
                                                        name="login_bg_image"
                                                        accept="image/*"
                                                        type="file"
                                                        onChange={(event) => {
                                                            setFieldValue(
                                                                "login_bg_image",
                                                                event.currentTarget.files[0] || ""
                                                            );
                                                            event.currentTarget.files.length === 1
                                                                ? setPreviewImage(
                                                                    URL.createObjectURL(
                                                                        event.currentTarget.files[0]
                                                                    )
                                                                )
                                                                : setPreviewImage("");
                                                        }}
                                                    />
                                                    {console.log("previewImage", previewimage)}
                                                    {previewimage ? (
                                                        <div className="mb-4 text-left mt-1">
                                                            <img
                                                                src={previewimage}
                                                                alt="Preview"
                                                                style={{ height: "100px" }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>
                                                <div className="col-md-6 text-center form-group">
                                                    <label
                                                        htmlFor="login_bg_image_de"
                                                        className="text-left d-flex"
                                                    >
                                                        Login BG Image German:{" "}
                                                    </label>
                                                    <input
                                                        className="form-control imgInput"
                                                        id="login_bg_image_de"
                                                        name="login_bg_image_de"
                                                        accept="image/*"
                                                        type="file"
                                                        onChange={(event) => {
                                                            setFieldValue(
                                                                "login_bg_image_de",
                                                                event.currentTarget.files[0] || ""
                                                            );
                                                            event.currentTarget.files.length === 1
                                                                ? setPreviewImageGerman(
                                                                    URL.createObjectURL(
                                                                        event.currentTarget.files[0]
                                                                    )
                                                                )
                                                                : setPreviewImageGerman("");
                                                        }}
                                                    />
                                                    {previewImageGerman ? (
                                                        <div className="mb-4 mt-1 text-left">
                                                            <img
                                                                src={previewImageGerman}
                                                                alt="Preview"
                                                                style={{ height: "100px" }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>
                                                <div className="col-md-6 text-center form-group">
                                                    <label
                                                        htmlFor="richtext"
                                                        className="text-left d-flex"
                                                    >
                                                        Login Page Content:
                                                        <span className="requirestar">*</span>{" "}
                                                    </label>
                                                    {dataLoaded ? (
                                                        <CustomCkeditor
                                                            fieldname={"richtext"}
                                                            setFieldValue={setFieldValue}
                                                            value={values.richtext}
                                                            setFieldTouched={setFieldTouched}
                                                        />
                                                    ) : (
                                                        <></>
                                                    )}
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.richtext &&
                                                            touched.richtext &&
                                                            errors.richtext}
                                                    </span>
                                                </div>
                                                <div className="col-md-6 text-center form-group">
                                                    <label
                                                        htmlFor="richtext_de"
                                                        className="text-left d-flex"
                                                    >
                                                        Login Page Content German:
                                                    </label>
                                                    {dataLoaded ? (
                                                        <CustomCkeditor
                                                            fieldname={"richtext_de"}
                                                            setFieldValue={setFieldValue}
                                                            value={values.richtext_de}
                                                            setFieldTouched={setFieldTouched}
                                                        />
                                                    ) : (
                                                        <></>
                                                    )}
                                                </div>
                                                <div className="col-md-6 text-center form-group">
                                                    <label
                                                        htmlFor="cookies_content"
                                                        className="text-left d-flex"
                                                    >
                                                        Cookies Content:
                                                        <span className="requirestar">*</span>{" "}
                                                    </label>
                                                    {dataLoaded ? (
                                                        <CustomCkeditor
                                                            fieldname={"cookies_content"}
                                                            setFieldValue={setFieldValue}
                                                            value={values.cookies_content}
                                                            setFieldTouched={setFieldTouched}
                                                        />
                                                    ) : (
                                                        <></>
                                                    )}
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.cookies_content &&
                                                            touched.cookies_content &&
                                                            errors.cookies_content}
                                                    </span>
                                                </div>
                                                <div className="col-md-6 text-center form-group">
                                                    <label
                                                        htmlFor="cookies_content_de"
                                                        className="text-left d-flex"
                                                    >
                                                        Cookies Content German:
                                                        {" "}
                                                    </label>
                                                    {dataLoaded ? (
                                                        <CustomCkeditor
                                                            fieldname={"cookies_content_de"}
                                                            setFieldValue={setFieldValue}
                                                            value={values.cookies_content_de}
                                                            setFieldTouched={setFieldTouched}
                                                        />
                                                    ) : (
                                                        <></>
                                                    )}
                                                </div>
                                                <div className="col-md-12 text-center form-group">
                                                    <label
                                                        htmlFor="pay_by_invoice_content"
                                                        className="text-left d-flex"
                                                    >
                                                        Pay By Invoice Content:
                                                        <span className="requirestar">*</span>{" "}
                                                    </label>
                                                    {dataLoaded ? (
                                                        <CustomCkeditor
                                                            fieldname={"pay_by_invoice_content"}
                                                            setFieldValue={setFieldValue}
                                                            value={values.pay_by_invoice_content}
                                                            setFieldTouched={setFieldTouched}
                                                        />
                                                    ) : (
                                                        <></>
                                                    )}
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.pay_by_invoice_content &&
                                                            touched.pay_by_invoice_content &&
                                                            errors.pay_by_invoice_content}
                                                    </span>
                                                </div>
                                                <div className="col-md-12 text-center form-group">
                                                    <label
                                                        htmlFor="invoice_footer"
                                                        className="text-left d-flex"
                                                    >
                                                        Invoice Footer:
                                                        <span className="requirestar">*</span>{" "}
                                                    </label>
                                                    <input
                                                            name="invoice_footer"
                                                            type="text"
                                                            id="invoice_footer"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.invoice_footer}
                                                            className="form-control"
                                                        />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.invoice_footer &&
                                                            touched.invoice_footer &&
                                                            errors.invoice_footer}
                                                    </span>
                                                </div>
                                                <div className="col-md-6 text-center form-group">
                                                    <label
                                                        htmlFor="ticket_prefix_text"
                                                        className="text-left d-flex"
                                                    >
                                                        Ticket Prefix Text:
                                                        <span className="requirestar">*</span>
                                                    </label>
                                                    <input
                                                        name="ticket_prefix_text"
                                                        type="text"
                                                        id="ticket_prefix_text"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.ticket_prefix_text}
                                                        className="form-control"
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.ticket_prefix_text &&
                                                            touched.ticket_prefix_text &&
                                                            errors.ticket_prefix_text}
                                                    </span>
                                                </div>
                                                <div className="col-md-6 text-center form-group">
                                                    <label
                                                        htmlFor="ticket_prefix_number"
                                                        className="text-left d-flex"
                                                    >
                                                        Ticket Prefix Number:
                                                        <span className="requirestar">*</span>
                                                    </label>
                                                    <input
                                                        name="ticket_prefix_number"
                                                        type="number"
                                                        id="ticket_prefix_number"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.ticket_prefix_number}
                                                        className="form-control"
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.ticket_prefix_number &&
                                                            touched.ticket_prefix_number &&
                                                            errors.ticket_prefix_number}
                                                    </span>
                                                </div>
                                                <div className="col-md-12 text-center form-group">
                                                    <label
                                                        htmlFor="ticket_footer_text"
                                                        className="text-left d-flex"
                                                    >
                                                        Ticket Footer Text:
                                                        {/* <span className="requirestar">*</span>{" "} */}
                                                    </label>
                                                    {dataLoaded ? (
                                                        <CustomCkeditor
                                                            fieldname={"ticket_footer_text"}
                                                            setFieldValue={setFieldValue}
                                                            value={values.ticket_footer_text}
                                                            setFieldTouched={setFieldTouched}
                                                        />
                                                    ) : (
                                                        <></>
                                                    )}
                                                    {/* <span className="text-danger d-flex text-left">
                                                        {errors.ticket_footer_text &&
                                                            touched.ticket_footer_text &&
                                                            errors.ticket_footer_text}
                                                    </span> */}
                                                </div>
                                                {hasPermission("/admin/cms/settings/submit") ? (
                                                    <div className="">
                                                        <button
                                                            className="btn btn-main-primary signbtn mr-2"
                                                            type="submit"
                                                            disabled={submitted ? true : null}
                                                            onClick={() => {
                                                                setSubmitClicked(true);
                                                            }}
                                                        >
                                                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                            Submit
                                                        </button>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            ) : (
                <Loader />
            )}
            <Modal
                size="lg"
                open={showTermsModal}
                onClose={() => {
                    formik.resetForm();
                    setShowTermsModal(false);
                }}
                backdrop="static">
                <div>
                    <Modal.Header>
                        <Modal.Title>Edit Terms & Conditions</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-6 form-group">
                                <label className="d-flex">
                                    Terms and Condition One <span className="requirestar">*</span>
                                </label>
                                <CustomCkeditor
                                    fieldname="TermsAndConditionOne"
                                    value={formik.values.TermsAndConditionOne}
                                    setFieldValue={formik.setFieldValue}
                                    setFieldTouched={formik.setFieldTouched}
                                />
                                {formik.touched.TermsAndConditionOne && formik.errors.TermsAndConditionOne && (
                                    <span className="text-danger d-flex">{formik.errors.TermsAndConditionOne}</span>
                                )}
                            </div>
                            <div className="col-md-6 form-group">
                                <label className="d-flex">Terms and Condition One (German)</label>
                                <CustomCkeditor
                                    fieldname="TermsAndConditionOneDe"
                                    value={formik.values.TermsAndConditionOneDe}
                                    setFieldValue={formik.setFieldValue}
                                    setFieldTouched={formik.setFieldTouched}
                                />
                            </div>
                            <div className="col-md-6 form-group">
                                <label className="d-flex">
                                    Terms and Condition Two <span className="requirestar">*</span>
                                </label>
                                <CustomCkeditor
                                    fieldname="TermsAndConditionTwo"
                                    value={formik.values.TermsAndConditionTwo}
                                    setFieldValue={formik.setFieldValue}
                                    setFieldTouched={formik.setFieldTouched}
                                />
                                {formik.touched.TermsAndConditionTwo && formik.errors.TermsAndConditionTwo && (
                                    <span className="text-danger d-flex">{formik.errors.TermsAndConditionTwo}</span>
                                )}
                            </div>
                            <div className="col-md-6 form-group">
                                <label className="d-flex">Terms and Condition Two (German)</label>
                                <CustomCkeditor
                                    fieldname="TermsAndConditionTwoDe"
                                    value={formik.values.TermsAndConditionTwoDe}
                                    setFieldValue={formik.setFieldValue}
                                    setFieldTouched={formik.setFieldTouched}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={formik.handleSubmit} appearance="primary">
                            Save
                        </Button>
                    </Modal.Footer>
                </div>
            </Modal>
        </>
    );
};

export default GlobalPlatformSettings;
